import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface LoaderState {
  loader: boolean;
}

const initialState: LoaderState = {
  loader: false,
};

const loaderSlice = createSlice({
  name: "pageLoader",
  initialState,
  reducers: {
    setLoaderState(state, action: PayloadAction<boolean>) {
      state.loader = action.payload;
    },
  },
});

export const { setLoaderState } = loaderSlice.actions;
export default loaderSlice.reducer;
export const loaderSelector = (state: RootState) => state.pageLoader.loader;
